import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import {
	IClauseByIdRatificacaoResponse,
	IClauseByIdReponse,
	IClauseCreateRequest,
	IClauseForTable,
	IClauseQueryReponse,
	IClauseQueryRequest
} from "../interfaces/clause.interface";
import { IFilterClauseRequest } from "../interfaces/filter.interface";
import { IResponseData, IResponseListDataPaginate } from "../interfaces/response-data.interface";

@Injectable({
	providedIn: "root"
})
export class ClauseService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getAll(request: IClauseQueryRequest): Observable<IResponseListDataPaginate<IClauseQueryReponse>> {
		let params = new HttpParams();
		if (request.clauseName !== "" && request.clauseName !== undefined && request.clauseName !== null) {
			params = params.append("clauseName", request.clauseName);
		}
		if (request.takerName !== "" && request.takerName !== undefined && request.takerName !== null) {
			params = params.append("takerName", request.takerName);
		}
		if (request.insuredName !== "" && request.insuredName !== undefined && request.insuredName !== null) {
			params = params.append("insuredName", request.insuredName);
		}
		if (request.productId !== "" && request.productId !== undefined && request.productId !== null) {
			params = params.append("productId", request.productId);
		}
		if (request.clauseType !== "" && request.clauseType !== undefined && request.clauseType !== null) {
			params = params.append("clauseType", request.clauseType);
		}
		if (
			request.clauseTypeAplication !== "" &&
			request.clauseTypeAplication !== undefined &&
			request.clauseTypeAplication !== null
		) {
			params = params.append("clauseTypeAplication", request.clauseTypeAplication);
		}
		if (request.coverageId !== "" && request.coverageId !== undefined && request.coverageId !== null) {
			params = params.append("coverageId", request.coverageId);
		}
		if (request.clauseStatus !== "" && request.clauseStatus !== undefined && request.clauseStatus !== null) {
			params = params.append("clauseStatus", request.clauseStatus);
		}
		if (request.page !== undefined) {
			params = params.append("page", request.page.toString());
		}
		if (request.pageSize !== undefined) {
			params = params.append("pageSize", request.pageSize.toString());
		}

		return this.http.get<IResponseListDataPaginate<IClauseQueryReponse>>(`${environment.urlApi}/clause/filter`, {
			params
		});
	}

	getById(id: number): Observable<IResponseData<IClauseByIdReponse>> {
		return this.http.get<IResponseData<IClauseByIdReponse>>(`${environment.urlApi}/Clause/GetById?id=${id}`);
	}

	getByIdRatificacao(id: number): Observable<IResponseData<IClauseByIdRatificacaoResponse>> {
		return this.http.get<IResponseData<IClauseByIdRatificacaoResponse>>(
			`${environment.urlApi}/Clause/GetByIdRatificacao?id=${id}`
		);
	}

	getClausesTableByTakerId(
		takerId: number,
		cdProduto: any,
		coverageId: any,
		insuredId: number
	): Observable<IResponseData<[IClauseForTable]>> {
		if(takerId != null){
			return this.http.get<IResponseData<[IClauseForTable]>>(
				`${environment.urlApi}/Clause/GetClausesTableByTakerId?takerId=${takerId}&cdProduto=${cdProduto}&coverageId=${coverageId}&insuredId=${insuredId}`
			);
		}
	}

	getClausesTableByProposalId(idProposal: number): Observable<IResponseData<[IClauseForTable]>> {
		return this.http.get<IResponseData<[IClauseForTable]>>(
			`${environment.urlApi}/Clause/getClausesTableByProposalId?idProposal=${idProposal}`
		);
	}

	getClausulasByPropostaAdiantamentoId(idProposal: number): Observable<IResponseData<[IClauseForTable]>> {
		return this.http.get<IResponseData<[IClauseForTable]>>(
			`${environment.urlApi}/Clause/GetClausulasByPropostaAdiantamentoId?idProposal=${idProposal}`
		);
	}

	getClausesWithoutTaker(
		cdProduto: any,
		coverageId: any,
		insuredId: number
	): Observable<IResponseData<[IClauseForTable]>> {
		return this.http.get<IResponseData<[IClauseForTable]>>(
			`${environment.urlApi}/Clause/getClausesWithoutTaker?cdProduto=${cdProduto}&coverageId=${coverageId}&insuredId=${insuredId}`
		);
	}

	getToName(request: IFilterClauseRequest): Observable<any> {
		let params = new HttpParams();
		if (request.name !== "" && request.name !== undefined) {
			params = params.append("name", request.name);
		}
		return this.http.get<any>(`${environment.urlApi}/clause/gettoname`, { params });
	}

	getNameAtivoClause(): Observable<any> {
		const params = new HttpParams();
		return this.http.get<any>(`${environment.urlApi}/clause/GetNameAtivoClause`, { params });
	}

	getClauseTypeAll(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/clause/GetClauseTypeAll`);
	}

	getClauseTypeAplicationAll(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Clause/GetClauseTypeAplicationsAl`);
	}

	update(request: IClauseCreateRequest): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/clause/update`, request);
	}

	disable(request: any): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/Clause/Disable`, request);
	}

	post(request: IClauseCreateRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/clause/insert`, request);
	}
}
